import { render, staticRenderFns } from "./addspecialoffer.vue?vue&type=template&id=4f8fe2d2&scoped=true"
import script from "./addspecialoffer.vue?vue&type=script&lang=js"
export * from "./addspecialoffer.vue?vue&type=script&lang=js"
import style0 from "./addspecialoffer.vue?vue&type=style&index=0&id=4f8fe2d2&lang=less"
import style1 from "./addspecialoffer.vue?vue&type=style&index=1&id=4f8fe2d2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fe2d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f8fe2d2')) {
      api.createRecord('4f8fe2d2', component.options)
    } else {
      api.reload('4f8fe2d2', component.options)
    }
    module.hot.accept("./addspecialoffer.vue?vue&type=template&id=4f8fe2d2&scoped=true", function () {
      api.rerender('4f8fe2d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/addspecialoffer.vue"
export default component.exports